class RefillDiscountController {
  /* @ngInject */
  constructor($log, $interval, Endpoints, Discounts, Promos, Services, MedicationPrice, toastr) {
    Object.assign(this, {
      $log,
      $interval,
      Endpoints,
      Discounts,
      Promos,
      Services,
      MedicationPrice,
      toastr,
      adding: false,
      editing: false
    });
    this.getCategories();
    this.getPromos();
    this.getRefillDiscounts();
  }

  changeCategory() {
    // We refresh list of Medications according to the Service
    this.getMedicationsByCategory();
  }

  getCategories() {
    this.Services.list().then(({
      data
    }) => {
      var categories = [];
      data.data.sort(function (a, b) {
        if (a.name < b.name) {
          return -1;
        }

        if (a.name > b.name) {
          return 1;
        }

        return 0;
      });
      data.data.forEach(category => {
        if (category.children && category.children.length) {
          category.children.forEach(child => {
            child.code_name = child.code + ' - ' + child.name;
            categories.push(child);
          });
        } else {
          category.code_name = category.code + ' - ' + category.name;
          categories.push(category);
        }
      });
      categories.unshift({
        code_name: "Please select a service"
      });
      this.categories = categories;
      this.selectedCategory = this.categories[0];
    }).catch(err => {
      this.categories = [];
      this.toastr.error('Error getting services: ' + JSON.stringify(err));
    });
  }

  getMedicationsByCategory() {
    this.Services.getMedicationListByCategory(this.selectedCategory.code).then(({
      data
    }) => {
      data.sort(function (a, b) {
        if (a.medication_name < b.medication_name) {
          return -1;
        }

        if (a.medication_name > b.medication_name) {
          return 1;
        }

        return 0;
      });
      data.forEach(medication => {
        medication.id_name = medication.medication_id + ' - ' + medication.medication_name;
      });
      data.unshift({
        id_name: "Please select a medication"
      });
      this.medications = data;
      this.selectedMedication = this.medications[0];
    }).catch(err => {
      this.medications = [];
      this.toastr.error('Error getting medications by service: ' + JSON.stringify(err));
    });
  }

  getPromos() {
    this.Promos.all({
      limit: 1000
    }).then(({
      data
    }) => {
      data.data.forEach(promo => {
        promo.id_name_type_discount = promo.id + ' - ' + promo.name + ' - ' + promo.type + ' - ' + promo.discount.type + ' ' + promo.discount.value;
      });
      data.data.unshift({
        id_name_type_discount: "Please select a promo"
      });
      this.promos = data.data;
      this.selectedPromo = this.promos[0];
    }).catch(err => {
      this.promos = [];

      if (err && err.status && err.status == 403) {
        this.toastr.error("Error: Access denied to get promo codes list.");
      } else {
        this.toastr.error("Error getting promo codes list: " + JSON.stringify(err));
      }
    });
  }

  getRefillDiscounts() {
    this.Discounts.listRefillDiscount().then(({
      data
    }) => {
      this.results = data;
    }).catch(err => {
      this.results = [];
      this.toastr.error('Error getting refill discounts: ' + JSON.stringify(err));
    });
  }

  edit(row) {
    this.editing = true;
    this.category_medication_promos_xref_id = row.category_medication_promos_xref_id;
    this.category = row.category_code + ' - ' + row.category_name;
    this.medication = row.medication_id + ' - ' + row.medication_code;
    this.selectedPromo = this.promos.find(x => x.id === row.promo_id);
    this.refill_count = row.refill_count;
    this.display_selected = row.display_selected;
    this.active = row.active;
  }

  add() {
    this.adding = true;
    this.refill_count = 1;
    this.display_selected = 0;
    this.active = 1;
  }

  cancelAddRefillDiscount() {
    this.adding = false;
  }

  cancelEditRefillDiscount() {
    this.editing = false;
  }

  updateRefillDiscount() {
    var this2 = this;

    if (this.selectedPromo.id_name_type_discount == 'Please select a promo') {
      this.toastr.warning('Please select a promo');
      return;
    }

    if (this.refill_count == null || isNaN(this.refill_count)) {
      this.toastr.warning('Please enter the number of refills');
      return;
    }

    var payload = {
      promo_id: this.selectedPromo.id,
      refill_count: this.refill_count,
      display_selected: this.display_selected,
      active: this.active
    };
    this.Discounts.updateRefillDiscount(this.category_medication_promos_xref_id, payload).then(() => {
      this.toastr.success('Refill discount updated successfully');
      this2.filteredResults.forEach(discount => {
        if (discount.category_medication_promos_xref_id == this2.category_medication_promos_xref_id) {
          discount.promo_id = this2.selectedPromo.id;
          discount.promo_name = this2.selectedPromo.name;
          discount.promo_type = this2.selectedPromo.type;
          discount.promo_discount_type = this2.selectedPromo.discount.type;
          discount.promo_discount_value = this2.selectedPromo.discount.value;
          discount.refill_count = this2.refill_count;
          discount.display_selected = this2.display_selected;
          discount.active = this2.active;
        }
      });
      this.editing = false;
    }).catch(err => {
      console.log(err);
      this.toastr.error('Error updating refill discount: ' + JSON.stringify(err));
    });
  }

  addRefillDiscount() {
    if (this.selectedCategory.code_name == 'Please select a service') {
      this.toastr.warning('Please select a service');
      return;
    }

    if (!this.selectedMedication || this.selectedMedication.id_name == 'Please select a medication') {
      this.toastr.warning('Please select a medication');
      return;
    }

    if (this.selectedPromo.id_name_type_discount == 'Please select a promo') {
      this.toastr.warning('Please select a promo');
      return;
    }

    if (this.refill_count == null || isNaN(this.refill_count)) {
      this.toastr.warning('Please enter the number of refills');
      return;
    }

    var payload = {
      promo_id: this.selectedPromo.id,
      refill_count: this.refill_count,
      display_selected: this.display_selected,
      active: this.active
    };
    this.Discounts.addRefillDiscountByCategoryAndMedication(this.selectedCategory.id, this.selectedMedication.medication_id, payload).then(() => {
      this.toastr.success('Refill discount added successfully');
      this.getRefillDiscounts();
    }).catch(err => {
      console.log(err);
      this.toastr.error('Error adding refill discount: ' + JSON.stringify(err));
    });
  }

}

RefillDiscountController.$inject = ["$log", "$interval", "Endpoints", "Discounts", "Promos", "Services", "MedicationPrice", "toastr"];
angular.module('pims').controller('RefillDiscountController', RefillDiscountController);